import { Dialog, DialogTitle, DialogContent, TableContainer, Table, TableHead, TableRow, TableCell, Typography, TableBody, Button, DialogActions, Box } from "@mui/material";
import { TModalValues } from "..";
import { useMemo } from "react";
import tratativaDeDatas from "../../../../../../../../helpers/tratativaDeDatas";
import { formatarValorMonetario } from "../../../../../../../../helpers/masks";

export default function DialogListaLancamentos({ open, valores, onClose }: DialogListaLancamentosProps) {

    const formatedValues = useMemo(() => {
        const titulos_receber: TValores[] = valores.titulos_receber.map(titulo => {
            if (titulo.saldo_principal > 0) {
                return {
                    documento: `${titulo.tipo_documento}-${titulo.numero_documento}/${titulo.sequencia_documento}`,
                    data_emissao: titulo.data_emissao,
                    data_vencimento: titulo.data_vencimento,
                    data_lancamento: null,
                    valor: titulo.saldo_simulado,
                    historico: titulo.historico === ' ' ? '-' : titulo.historico,
                    loja: titulo.loja_id.toString(),
                    tipo: 'Débito'
                }
            }
            return null
        }).filter((item): item is NonNullable<typeof item> => item !== null);

        const titulos_pagar: TValores[] = valores.titulos_pagar.map(titulo => {
            if (titulo.saldo_principal > 0) {
                return {
                    documento: `${titulo.tipo_documento}-${titulo.numero_documento}/${titulo.sequencia_documento}`,
                    data_emissao: titulo.data_emissao,
                    data_vencimento: titulo.data_vencimento,
                    data_lancamento: null,
                    valor: titulo.saldo_principal,
                    historico: titulo.historico === ' ' ? '-' : titulo.historico,
                    loja: '-',
                    tipo: 'Crédito'
                }
            }
            return null
        }).filter((item): item is NonNullable<typeof item> => item !== null);

        const lancamentos: TValores[] = valores.lancamentos
            .map(lancamento => {
                if (lancamento.tipo_lancamento === "C" && lancamento.valor_lancamento > 0) {
                    return {
                        documento: `${lancamento.numero_documento}`,
                        data_emissao: lancamento.data_emissao,
                        data_vencimento: lancamento.data_vencimento,
                        data_lancamento: lancamento.data_lancamento,
                        valor: lancamento.valor_lancamento,
                        historico: lancamento.historico_lancamento === ' ' ? '-' : lancamento.historico_lancamento,
                        loja: lancamento.loja_id.toString(),
                        tipo: 'Crédito'
                    };
                }
                if (lancamento.tipo_lancamento !== "C" && lancamento.valor_lancamento > 0) {
                    return {
                        documento: `${lancamento.numero_documento}`,
                        data_emissao: lancamento.data_emissao,
                        data_vencimento: lancamento.data_vencimento,
                        data_lancamento: lancamento.data_lancamento,
                        valor: lancamento.valor_lancamento,
                        historico: lancamento.historico_lancamento,
                        loja: lancamento.loja_id.toString(),
                        tipo: 'Débito'
                    }
                }
                return null;
            })
            .filter((item): item is NonNullable<typeof item> => item !== null);

        return titulos_receber.concat(titulos_pagar).concat(lancamentos);
    }, [valores])

    const valorTotal = formatedValues.reduce((acc, curr) => {
        return curr.tipo === 'Crédito' ? acc + curr.valor : acc - curr.valor;
    }, 0);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle>
                Lista de lançamentos
                <Typography variant="body1"><b>{valores.tipo_publico}{valores.publico_codigo} - {valores.publico_nome}</b></Typography>
            </DialogTitle>
            <DialogContent>
                <Box mb={2}>
                </Box>
                <>
                    {
                        formatedValues.length > 0 &&
                        <TableListaLancamentos valores={formatedValues} />
                    }

                </>
            </DialogContent>
            <DialogActions>
                <Box mx={2} py={1} width={'100%'} display={'flex'} justifyContent={'space-between'}>
                    <Box display={'flex'} alignItems={'center'} gap={1}>
                        <Typography><b>Valor total:</b></Typography>
                        <Typography color={valorTotal > 0 ? '#1B5E20' : '#960000'}><b>{formatarValorMonetario(Math.abs(valorTotal))}</b></Typography>
                    </Box>
                    <Button variant='outlined' onClick={onClose}>Fechar</Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

interface DialogListaLancamentosProps {
    open: boolean
    valores: TModalValues
    onClose: () => void
}

function TableListaLancamentos({ valores }: TableListaLancamentosProps) {

    return (
        <TableContainer sx={{
            maxHeight: '50vh',
            '& ::-webkit-scrollbar': {
                width: '8px',
            },
            '& ::-webkit-scrollbar-thumb': {
                backgroundColor: '#bdbdbd',
                borderRadius: '4px',
            }
        }}>
            <Table stickyHeader size="small">
                <TableHead >
                    <TableRow>
                        <TableCell><b>Documento</b></TableCell>
                        <TableCell><b>Data emissão</b></TableCell>
                        <TableCell><b>Data vencimento</b></TableCell>
                        <TableCell><b>Data lançamento</b></TableCell>
                        <TableCell><b>Histórico</b></TableCell>
                        <TableCell><b>Loja</b></TableCell>
                        <TableCell><b>Tipo</b></TableCell>
                        <TableCell align="right"><b>Valor</b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        valores.map((item, index) => (
                            <TableRow
                                key={index}
                                sx={{
                                    '&:last-child td, &:last-child th': {
                                        border: 0,
                                    }
                                }}
                            >
                                <TableCell>{item.documento}</TableCell>
                                <TableCell>{tratativaDeDatas(item.data_emissao)}</TableCell>
                                <TableCell>{tratativaDeDatas(item.data_vencimento)}</TableCell>
                                <TableCell>{tratativaDeDatas(item.data_lancamento)}</TableCell>
                                <TableCell>{item.historico}</TableCell>
                                <TableCell>{item.loja}</TableCell>
                                <TableCell>{item.tipo}</TableCell>
                                <TableCell align="right">
                                    <Typography variant="subtitle2" color={item.tipo === 'Crédito' ? '#1B5E20' : '#960000'}>
                                        {formatarValorMonetario(item.valor)}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
}

interface TableListaLancamentosProps {
    valores: Array<TValores>
}

type TValores = {
    documento: string
    data_emissao: string | null
    data_vencimento: string | null
    data_lancamento: string | null
    valor: number
    historico: string
    loja: string
    tipo: string
}